export const EXPERIMENTS = {
  USE_FIELDS_V2: 'specs.forms.UseFieldsV2',
  ENABLE_SUBMIT_LIMITS_SETTINGS: 'specs.forms.EnableSubmitLimitsSettings',
  APPOINTMENT_FIELD_V11: 'specs.forms.EnableAppointmentFieldV11',
  ENABLE_RICH_TEXT_SETTINGS: 'specs.forms.EnableRichTextSettings',
  SERVICE_DROPDOWN_OTHER_OPTIONS: 'specs.forms.ServiceDropdownOtherOptions',
  ENABLE_VALIDATION_BY_PATTERN_SETTING: 'specs.forms.EnableValidationByPatternSetting',
  ENABLE_FLOATING_ACTION_TOOLBAR: 'specs.forms.EnableFloatingActionToolbar'
};
//# sourceMappingURL=experiments.js.map